import { api } from '../../api'

export const deleteCustomerService = async (customerId: string) => {
  await api.delete(`/api/backoffice/customers/${customerId}`)
}
